<template>
  <div class="hello">
      <h1>Email Verification Successful</h1>
  </div>
</template>

<script>
import {phone_countries, country_abbreviation_to_country_code} from '@/settings';
export default {
  props: ['auth'],
  data: () => ({
    cc: '',
  }), 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
